import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
    GET_TICKETS_REQUEST,
    getTicketsSuccess,
    getTicketsFailure,
    SUBMIT_TICKETS_REQUEST,
    submitTicketsSuccess,
    submitTicketsFailure,
    setSumitTicketSuccess,
    CLOSE_PING_EVENT_TICEKTS,
    setSumitTicketFetching,
    GET_TICKET_REQUEST,
    getTicketSuccess,
    getTicketFailure,
    GET_EXPORT_REQUEST,
    getExportTicketSucces,
    getExportTicketFailure,
    GET_COMPANY_PLANS_REQUEST,
    getCompanyPlansSuccess,
    getCompanyPlansFailure,
    GET_NON_INSTALLATION_REASONS_REQUEST,
    getNonInstallationReasonsSuccess,
    getNonInstallationReasonsFailure
} from '../actions/tickets';
import { getTickets, postTicket, putTicket, getExportIdService, getCompanyPlans, getNonInstallationReasons } from '../services/tickets';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { prepareDataToSend } from '../helpers/tickets';
import { pingEvent } from '../../shared/sagas/events';
import { pingEventExport } from '../../shared/sagas/eventsExport';
import { cdnGetFilesApiAdmin } from '../../app/conf';

const getExportIdTickets = function* ({ payload: { filters, type } }) {
  try {
    const accessToken = yield select(accessTokenSelector);

    yield call(getExportIdService, filters, type, accessToken);

    yield put(getExportTicketSucces());
  } catch (err) {
    yield put(getExportTicketFailure(err));
  }
};


const getTicketsWorker = function* ({ payload: { filters, type } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { tickets, total }
        } = yield call(getTickets, filters, type, token);

        yield put(getTicketsSuccess(tickets, total, type));
    } catch (err) {
        yield put(getTicketsFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getTicketWorker = function* ({ payload: { filters, type } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { tickets }
        } = yield call(getTickets, filters, type, token);

        yield put(getTicketSuccess(tickets[0] || {}, type));

    } catch (err) {
        yield put(getTicketFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitTicketsWorker = function* ({ payload: { ticket, type } }) {

    try {

        const token = yield select(accessTokenSelector);

        const data = prepareDataToSend(ticket);

        if (!ticket._id) {
            const { data: { ticket: respTicket } } = yield call(postTicket, data, type, token);

            if (ticket.vehicle.image) {
                ticket.vehicle.image = cdnGetFilesApiAdmin(ticket.vehicle.image);
            }

            yield put(submitTicketsSuccess({
                ...ticket,
                _id: respTicket._id,
                taskId: ('00000000' + respTicket.taskId).slice(-8),
                subject: data.subject
            }));
            yield put(showGlobalError(true, 200, 'created'));
        } else {

            const { data: { event  } } = yield call(putTicket, data, type, token);

            let respClosePingEvent = false;

            if (event) {
                const resp = yield call(pingEvent, event, token, CLOSE_PING_EVENT_TICEKTS);
                respClosePingEvent = resp && resp.type === CLOSE_PING_EVENT_TICEKTS;
            }

            if (ticket.vehicle.image && !String(ticket.vehicle.image).includes(cdnGetFilesApiAdmin(""))) {
                ticket.vehicle.image = cdnGetFilesApiAdmin(ticket.vehicle.image);
            }


            // let newProperties = ticket.properties.map(p => { 
            //     if (p.id === 'vehicleColor'){
            //         return {
            //             ...p,
            //             value: ticket.vehicle.color
            //         }
            //     } else if(p.id === 'vehicleYear') {
            //         return {
            //             ...p,
            //             value: ticket.vehicle.year
            //         }
            //     } else {
            //         return { ...p };
            //     }

            // })

            if (!respClosePingEvent) {
                // yield put(submitTicketsSuccess({ ...ticket, properties: newProperties }));

                yield put(submitTicketsSuccess({ ...ticket }));

                yield put(showGlobalError(true, 200, 'updated'));
            } else {
                yield put(setSumitTicketFetching());
            }

        }

        yield put(setSumitTicketSuccess());

    } catch (err) {
        console.log(err)
        if (err && err.response && err.response.status && err.response.status === 412) {
            yield put(showGlobalError(true, 200, 'ticket_modified'));
            yield put(submitTicketsFailure(err));
        } else {
            // Check if there's a specific error message from the backend
            if (err && err.response && err.response.data && err.response.data.error) {
                const errorMessage = err.response.data.error;
                yield put(showGlobalError(true, { message: { key: errorMessage } }));
            } else {
                yield put(showGlobalError(true, err));
            }
            yield put(submitTicketsFailure(err));
        }
        
    }
};

const getCompanyPlansWorker = function* ({ payload: { companyId } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { company }
          } = yield call(getCompanyPlans, companyId, token);
          
          yield put(
            getCompanyPlansSuccess(company, company.plans, company.plans.length)
          );
          
    } catch (err) {
        yield put(getCompanyPlansFailure(err));
        yield put(showGlobalError(true, err));
    }
};


const getNonInstallationReasonsWorker = function* () {
    try {
        const token = yield select(accessTokenSelector);
        const { data } = yield call(getNonInstallationReasons, token);
        yield put(getNonInstallationReasonsSuccess(data));
    } catch (err) {
        yield put(getNonInstallationReasonsFailure(err));
    }
};

export default [
    takeLatest(GET_TICKETS_REQUEST, getTicketsWorker),
    takeLatest(SUBMIT_TICKETS_REQUEST, submitTicketsWorker),
    takeLatest(GET_TICKET_REQUEST, getTicketWorker),
    takeLatest(GET_EXPORT_REQUEST, getExportIdTickets),
    takeLatest(GET_COMPANY_PLANS_REQUEST, getCompanyPlansWorker),
    takeLatest(GET_NON_INSTALLATION_REASONS_REQUEST, getNonInstallationReasonsWorker)
];
